function accordion() {
  var $parent = $('.accordion-item')
  var $accordions = $('.accordion-header', $parent)

  if ($accordions.length) {
    var firstAccordionTop = $accordions.first().offset().top

    $accordions.on('click', function() {
      var $this = $(this)
      var $previousChildren = $this.parent().prev()
      var index = $previousChildren.index() + 1
      var offset = firstAccordionTop + Math.abs(index * 53)

      if ($this.parent().hasClass('active')) {
        $this.next().slideToggle()
        $this.parent().removeClass('active')
      } else {
        $this.next().slideToggle()
        $this.parent().addClass('active')
      }
    })
  }
}
export { accordion }
